import React, { useEffect, useState, useLayoutEffect, useRef } from 'react';
import BottomSheet from '@growth/bottom-sheet';
import { use100Vh } from '@growth/custom-hooks/use100Vh';
import { useOutsideHandler } from '@growth/custom-hooks/useOutsideHandler';
import { _ as _taggedTemplateLiteralLoose } from '../../../../dist/taggedTemplateLiteralLoose-7a042257.esm.js';
import { textSizes } from '@growth/design-system';
import styled from 'styled-components';
import { createPortal } from 'react-dom';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;
var SelectElement = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 58px;\n\tpadding: 18px 14px;\n\t", "\n\tcolor: #141823;\n\tborder: 1px solid rgba(0, 0, 0, 0.12);\n\tborder-radius: 4px;\n\tposition: relative;\n\tcursor: pointer;\n\t", "\n\t&::after {\n\t\tcontent: '';\n\t\tborder: solid #647a97;\n\t\tdisplay: inline-flex;\n\t\tborder-width: 0 2px 2px 0;\n\t\tpadding: 4px;\n\t\ttransform: rotate(45deg);\n\t\tposition: absolute;\n\t\tright: 17px;\n\t\ttop: 22px;\n\t}\n"])), textSizes.BaseW3, function (p) {
  return p.isActive && "\n    border-color: #2276E3;\n  ";
});
var SelectLabel = styled.label(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tleft: 18px;\n\ttop: 19px;\n\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: #777777;\n\tfont-weight: 700;\n\ttransition: all 0.3s ease-in-out;\n\t", "\n"])), function (p) {
  return p.isSelected && "\n    left: 14px;\n    top: -11px;\n    font-size: 12px;\n    font-weight: 400;\n    background: #fff;\n    padding: 0 4px;\n  ";
});
var SelectedOption = styled.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #141823;\n"])), textSizes.BaseW3);
var ModalHeader = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n\tpadding: 24px 20px 24px 24px;\n\tborder-radius: 20px 20px 0 0;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\t", "\n\th3 {\n\t\tfont-size: 1.8rem;\n\t\tfont-weight: 700;\n\t\tcolor: #141823;\n\t}\n\t.close {\n\t\tposition: absolute;\n\t\tright: 1.5rem;\n\t\ttop: 1.8rem;\n\t\twidth: 2.4rem;\n\t\theight: 2.4rem;\n\t}\n\t.close:before,\n\t.close:after {\n\t\tposition: absolute;\n\t\tleft: 1.1rem;\n\t\tcontent: ' ';\n\t\theight: 1.8rem;\n\t\twidth: 0.2rem;\n\t\tbackground-color: #141823;\n\t}\n\t.close:before {\n\t\ttransform: rotate(45deg);\n\t}\n\t.close:after {\n\t\ttransform: rotate(-45deg);\n\t}\n"])), textSizes.LargeW3);
var ModalInnerWrapper = styled.ul(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 0 20px;\n\theight: calc(var(--100vh) - 50px);\n\toverflow-y: scroll;\n\tpadding-bottom: 150px;\n"])));
var SearchItem$1 = styled.li(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tflex-shrink: 0;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-bottom: 12px;\n\tcursor: pointer;\n"])));
var LocationWrapper = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n"])));
var IconWrapper = styled.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n\tbackground: #f4f7fa;\n\tborder-radius: 4px;\n\tpadding: 12px;\n\twidth: 44px;\n\theight: 44px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin-right: 12px;\n"])));
var LocationName = styled.span(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #141823;\n"])), textSizes.MediumW1);
styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\twidth: 22px;\n\tbackground-repeat: no-repeat;\n\theight: 18px;\n\tbackground-image: url(\"data:image/svg+xml,%0A%3Csvg width='18' height='18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.636 2.637a9.005 9.005 0 0 1 12.73-.004 9.013 9.013 0 0 1 0 12.734 9.005 9.005 0 0 1-12.73-.004 8.998 8.998 0 0 1 0-12.726Zm9.867 9.854a.75.75 0 0 0 .027-1.03l-2.335-2.334a.188.188 0 0 1 0-.264l2.335-2.334a.75.75 0 1 0-1.062-1.062L9.134 7.801a.188.188 0 0 1-.266 0L6.534 5.467A.75.75 0 0 0 5.476 6.53L7.81 8.863a.187.187 0 0 1 0 .264L5.476 11.46a.75.75 0 0 0 0 1.062.765.765 0 0 0 1.062 0l2.334-2.334a.19.19 0 0 1 .266 0l2.334 2.334a.75.75 0 0 0 1.031-.03Z' fill='%23777'/%3E%3C/svg%3E\");\n"])));
var MapIcon = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\twidth: 23px;\n\tbackground-repeat: no-repeat;\n\theight: 22px;\n\tbackground-image: url(\"data:image/svg+xml,%0A%3Csvg width='14' height='18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 6.923A6.93 6.93 0 0 1 6.923 0a6.931 6.931 0 0 1 6.922 6.923c0 4.39-6.17 10.61-6.432 10.874a.692.692 0 0 1-.98 0C6.17 17.534 0 11.313 0 6.923Zm4.499 0a2.423 2.423 0 1 0 4.846 0 2.423 2.423 0 0 0-4.846 0Z' fill='%23647A97'/%3E%3C/svg%3E\");\n"])));

var SearchItem = function SearchItem(_ref) {
  var id = _ref.id,
    icon = _ref.icon,
    location = _ref.location,
    updateUserLocation = _ref.updateUserLocation,
    dealCount = _ref.dealCount;
  return /*#__PURE__*/React.createElement(SearchItem$1, {
    onClick: function onClick() {
      return updateUserLocation({
        locationId: id,
        locationName: location
      });
    }
  }, /*#__PURE__*/React.createElement(LocationWrapper, null, /*#__PURE__*/React.createElement(IconWrapper, null, icon), /*#__PURE__*/React.createElement(LocationName, null, location)), dealCount ? /*#__PURE__*/React.createElement("div", null, dealCount, " deals ") : null);
};
SearchItem.defaultProps = {
  dealCount: 0
};

var DropDownPortal = function DropDownPortal(_ref) {
  var children = _ref.children;
  var modalRoot = document.getElementById('bottom-sheet-root');
  if (!modalRoot) {
    modalRoot = document.createElement('div');
    modalRoot.setAttribute('id', 'bottom-sheet-root');
    document.body.appendChild(modalRoot);
  }
  var modalElement = document.createElement('div');
  useEffect(function () {
    var _modalRoot;
    (_modalRoot = modalRoot) == null || _modalRoot.appendChild(modalElement);
    return function () {
      var _modalRoot2;
      (_modalRoot2 = modalRoot) == null || _modalRoot2.removeChild(modalElement);
    };
  }, []);
  return /*#__PURE__*/createPortal(children, modalElement);
};

var MwebSearchModal = function MwebSearchModal(_ref) {
  var onLoad = _ref.onLoad,
    listToShow = _ref.listToShow,
    header = _ref.header,
    labelText = _ref.labelText,
    selectedVal = _ref.selectedVal,
    handleOptionSelected = _ref.handleOptionSelected;
  var _useState = useState(false),
    openDropDown = _useState[0],
    setOpenDropDown = _useState[1];
  useEffect(function () {
    onLoad == null || onLoad();
  }, []);
  var _use100Vh = use100Vh(),
    set100VhCssVar = _use100Vh[0];
  useLayoutEffect(function () {
    // set --100vh on css root var for bottom sheet height css
    set100VhCssVar();
  }, []);
  var ref = useRef();
  useOutsideHandler({
    eventName: 'touchstart',
    ref: ref,
    callback: function callback() {
      var _document;
      (_document = document) == null || (_document = _document.activeElement) == null || _document.blur();
    }
  });
  var toggleDropdown = function toggleDropdown() {
    setOpenDropDown(function (value) {
      return !value;
    });
  };
  var onOptionSelect = function onOptionSelect(value) {
    handleOptionSelected == null || handleOptionSelected({
      name: value.locationName,
      id: value.locationId
    });
    setOpenDropDown(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectElement, {
    onClick: toggleDropdown,
    isActive: openDropDown
  }, labelText && /*#__PURE__*/React.createElement(SelectLabel, {
    isSelected: selectedVal
  }, labelText), selectedVal && /*#__PURE__*/React.createElement(SelectedOption, null, selectedVal)), openDropDown ? /*#__PURE__*/React.createElement(DropDownPortal, null, /*#__PURE__*/React.createElement(BottomSheet, {
    closeBtn: true,
    shouldCloseOutSideClick: true,
    onClose: function onClose() {
      return setOpenDropDown(false);
    }
  }, /*#__PURE__*/React.createElement(ModalHeader, null, header), /*#__PURE__*/React.createElement(ModalInnerWrapper, null, listToShow.map(function (item) {
    return /*#__PURE__*/React.createElement(SearchItem, {
      updateUserLocation: function updateUserLocation(userLocation) {
        return onOptionSelect(userLocation);
      },
      icon: /*#__PURE__*/React.createElement(MapIcon, null),
      key: item.id,
      id: item.id,
      location: item.name
    });
  })))) : null);
};
MwebSearchModal.defaultProps = {
  onLoad: undefined
};

export { MwebSearchModal };
